import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { AmplitudeAnalyticsService as AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class UserLogoutService {

  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService,
    private _amplitudeService: AmplitudeAnalyticsService) { }
  public userLogout(): Observable<any> {
    this._amplitudeService.reset();
    const headers=this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpclient.post(environment.servicePath + '/lfuser/logout', {}, {headers});
  }
}
